import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Services from './components/Services';
import ForBrands from './components/ForBrands';
import ForCreators from './components/ForCreators';
import Results from './components/Results';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <ForBrands />
      <ForCreators />
      <Results />
      <Contact />
      <Footer />
    </div>
  );
}
